export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, shrink-to-fit=no"},{"charset":"utf-8"},{"property":"og:title","content":"Walbert-Schmitz GmbH"},{"property":"og:type","content":"website"},{"property":"og:description","content":"We create experiences"},{"property":"og:image","content":"https://walbert-schmitz.de/512px.png"},{"property":"og:url","content":"https://walbert-schmitz.de"},{"property":"og:locale","content":"de_DE"},{"property":"og:locale:alternate","content":"en_US"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"application-name","content":"Walbert-Schmitz GmbH"},{"name":"apple-mobile-web-app-title","content":"Walbert-Schmitz GmbH"},{"name":"theme-color","content":"#152029"},{"name":"msapplication-navbutton-color","content":"#152029"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"msapplication-starturl","content":"/"},{"name":"http-equiv='Content-Security-Policy'","content":"default-src 'self'; script-src 'self'"}],"link":[{"rel":"manifest","href":"/manifest.json"},{"rel":"preconnect","href":"https://ws-wire.w-s.app/api/"},{"rel":"icon","sizes":"16x16","href":"/16px.png"},{"rel":"apple-touch-icon","sizes":"16x16","href":"/16px.png"},{"rel":"icon","sizes":"32x32","href":"/32px.png"},{"rel":"apple-touch-icon","sizes":"32x32","href":"/32px.png"},{"rel":"icon","sizes":"46x46","href":"/46px.png"},{"rel":"apple-touch-icon","sizes":"46x46","href":"/46px.png"},{"rel":"icon","sizes":"120x120","href":"/120px.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/120px.png"},{"rel":"icon","sizes":"144x144","href":"/144px.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/144px.png"},{"rel":"icon","sizes":"192x192","href":"/192px.png"},{"rel":"apple-touch-icon","sizes":"192x192","href":"/192px.png"},{"rel":"icon","sizes":"384x384","href":"/384px.png"},{"rel":"apple-touch-icon","sizes":"384x384","href":"/384px.png"},{"rel":"icon","sizes":"512x512","href":"/512px.png"},{"rel":"apple-touch-icon","sizes":"512x512","href":"/512px.png"}],"style":[],"script":[],"noscript":[],"title":"Walbert-Schmitz GmbH","charset":"utf-8","viewport":"width=device-width, initial-scale=1, shrink-to-fit=no"}

export const appLayoutTransition = {"name":"layout","mode":"in-out"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true